module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-drawer', {
    staticClass: "elDrawer",
    attrs: {
      "visible": _vm.seeInquiryDetails,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.seeInquiryDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("询价单号: " + _vm._s(_vm.detailList.OrderNo))]), _vm._v(" "), _c('li', [_c('el-button', {
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelForm
          }
        }, [_vm._v("关 闭")])], 1)])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [(_vm.seeInquiryDetails) ? _c('div', {
    staticClass: "drawerDiv"
  }, [_c('p', [_vm._v("询价概况")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("当　前　状　态："), _c('span', [_vm._v(_vm._s(_vm.detailList.StatusName))])]), _vm._v(" "), _c('li', [_vm._v("询　价　城　市："), _c('span', [_vm._v(_vm._s(_vm.detailList.InquiryZone))])]), _vm._v(" "), _c('li', [_vm._v("剩余报价次数　："), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.detailList.QuoteCount))])])]), _vm._v(" "), _c('li', [_vm._v("询　价　预　算："), _c('span', [_vm._v(_vm._s(_vm.detailList.Budget))])])]), _vm._v(" "), _c('p', [_vm._v("询价基本信息")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("客户电话："), _c('span', [_vm._v(_vm._s(_vm.detailList.CustomerPhone))])]), _vm._v(" "), _c('li', [_vm._v("房屋面积："), _c('span', [_vm._v(_vm._s(_vm.detailList.BuildingArea))])]), _vm._v(" "), _c('li', [_vm._v("户　　型："), _c('span', [_vm._v(_vm._s(_vm.detailList.HouseType))])]), _vm._v(" "), _c('li', [_vm._v("风　　格："), _c('span', [_vm._v(_vm._s(_vm.detailList.Styles))])]), _vm._v(" "), _c('li', [_vm._v("询价品类："), _c('span', [_vm._v(_vm._s(_vm.detailList.BrandType))])]), _vm._v(" "), _c('li', [_vm._v("询价品牌："), _c('span', [_vm._v(_vm._s(_vm.detailList.Brands))])]), _vm._v(" "), _c('li', [_vm._v("图　　片："), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    style: ({
      color: _vm.detailList.InquiryImgs.length == 0 ? '#ccc' : '#F56C6C'
    }),
    on: {
      "click": function($event) {
        return _vm.seePicture(_vm.detailList.InquiryImgs)
      }
    }
  }, [_vm._v("\n            查看 (" + _vm._s(_vm.detailList.InquiryImgs.length) + ") 张")])]), _vm._v(" "), _c('li', [_vm._v("备　　注："), _c('span', [_vm._v(_vm._s(_vm.detailList.Remark))])])]), _vm._v(" "), _c('p', [_vm._v("询价商品")]), _vm._v(" "), _vm._l((_vm.detailList.BrandBusinessInquiryForQuerySingleOfGoodsModels), function(item, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v("商品型号："), _c('span', [_vm._v(_vm._s(item.GoodsCode))])]), _vm._v(" "), _c('li', [_vm._v("商品链接: "), _c('span', [_c('strong', {
      staticStyle: {
        "color": "#00f"
      },
      attrs: {
        "id": "content"
      }
    }, [_vm._v(_vm._s(item.GoodsUrl))]), _vm._v(" "), (item.GoodsUrl) ? _c('span', {
      staticClass: "copyTrackingNumber",
      attrs: {
        "data-clipboard-target": "#content"
      },
      on: {
        "click": _vm.copyTrackingNumber
      }
    }, [_vm._v("\n              拷贝\n            ")]) : _vm._e()])]), _vm._v(" "), _c('li', [_vm._v("品　　牌: "), _c('span', [_vm._v(_vm._s(item.Brand))])]), _vm._v(" "), _c('li', [_vm._v("图　　片："), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      style: ({
        color: item.GoodsImg.length == 0 ? '#ccc' : '#F56C6C'
      }),
      on: {
        "click": function($event) {
          return _vm.seePicture(item.GoodsImg)
        }
      }
    }, [_vm._v("\n            查看 (" + _vm._s(item.GoodsImg.length) + ") 张")])]), _vm._v(" "), _c('li', [_vm._v("备　　注："), _c('span', [_vm._v(_vm._s(item.Remark))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.seeInquiryDetails) ? _c('div', {
    staticClass: "drawer_foot"
  }, [(_vm.quoteRecordButton) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endQuotationRecord
    }
  }, [_vm._v("查看报价记录(" + _vm._s(_vm.detailList.QuoteCount.substring(1, 0)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.quoteButton) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endOffer
    }
  }, [_vm._v("报价(" + _vm._s(_vm.detailList.QuoteCount) + ")")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('BusinessQuotation', {
    ref: "refBusinessQuotation",
    attrs: {
      "inquiryId": _vm.inquiryId,
      "inquiryNo": _vm.inquiryNo
    },
    on: {
      "closeSee": _vm.cancelForm
    }
  }), _vm._v(" "), _c('QuotationRecord', {
    ref: "refQuotationRecord",
    attrs: {
      "inquiryId": _vm.inquiryId,
      "inquiryNo": _vm.inquiryNo,
      "dataAllList": _vm.dataAllList
    },
    on: {
      "closeSee": _vm.cancelForm
    }
  }), _vm._v(" "), _c('ViewPicture', {
    ref: "refViewPicture"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f216ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderManagement/InquiryDetails.vue
// module id = 1671
// module chunks = 3